import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import configStore from './lib/configStore';
import RootRouter from './routes/RootRouter';
import { ORANGE, LIGHT_GREY } from './styles/Colors';

export const store = configStore();

const theme = createMuiTheme({
  palette: {
    primary: {
      main: ORANGE,
    },
    secondary: {
      main: LIGHT_GREY,
    },
  },
});

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <RootRouter />
        </ThemeProvider>
      </Provider>
    );
  }
}

export default App;
